export default __webpack_public_path__ + "static/sdDistillersGuildFavicon-64b4984c7f13f2288440a2ae6b729ba8.png";